// mixins/datafastMixin.js

import { showDataFastError } from '@/services/datafastNotificationService'
import { validateRecurringPayment } from '@/utils/datafastTokenManager'

export default {
    methods: {
        insertDataFastPoweredByLogo() {
            const form =
                document.querySelector('form.wpwl-form-card') ||
                document.querySelector('.wpwl-form-card') ||
                document.querySelector('form.paymentWidgets') ||
                document.querySelector('.paymentWidgets')

            if (!form) return
            if (form.querySelector('.datafast-powered-by')) return

            const wrapper = document.createElement('div')
            wrapper.className = 'datafast-powered-by'
            wrapper.style.margin = '12px 0'

            const img = document.createElement('img')
            img.src = 'https://www.datafast.com.ec/images/verified.png'
            img.alt = 'Certificado Datafast'
            img.style.display = 'block'
            img.style.margin = '0 auto'
            img.style.width = '100%'

            wrapper.appendChild(img)

            const button = form.querySelector('.wpwl-button')
            if (button && button.parentNode)
                button.parentNode.insertBefore(wrapper, button)
            else form.appendChild(wrapper)
        },

        normalizeCardHolder(value) {
            return String(value || '')
                .trim()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .replace(/\s+/g, ' ')
                .toUpperCase()
        },

        getHolderInput() {
            return document.querySelector('input[name="card.holder"]')
        },

        getHolderWrapper(inputEl) {
            if (!inputEl) return null
            return (
                inputEl.closest('.wpwl-wrapper') ||
                inputEl.closest('.wpwl-group') ||
                inputEl.parentElement
            )
        },

        clearHolderError(inputEl) {
            const wrap = this.getHolderWrapper(inputEl)
            if (!wrap) return
            const hint = wrap.querySelector(
                '.wpwl-hint.wpwl-hint-error.datafast-field-error'
            )
            if (hint) hint.remove()
            // eslint-disable-next-line no-param-reassign
            inputEl.classList.remove('wpwl-has-error')
        },

        setHolderError(inputEl, message) {
            const wrap = this.getHolderWrapper(inputEl)
            if (!wrap) return

            const old = wrap.querySelector(
                '.wpwl-hint.wpwl-hint-error.datafast-field-error'
            )
            if (old) old.remove()

            if (!message) {
                // eslint-disable-next-line no-param-reassign
                inputEl.classList.remove('wpwl-has-error')
                return
            }

            // eslint-disable-next-line no-param-reassign
            inputEl.classList.add('wpwl-has-error')

            const hint = document.createElement('div')
            hint.className = 'wpwl-hint wpwl-hint-error datafast-field-error'
            hint.textContent = message

            if (inputEl.nextSibling)
                wrap.insertBefore(hint, inputEl.nextSibling)
            else wrap.appendChild(hint)
        },

        validateHolderInput(inputEl) {
            const normalized = this.normalizeCardHolder(inputEl.value)
            // eslint-disable-next-line no-param-reassign
            inputEl.value = normalized
            const ok = normalized.length >= 3 && /^[A-Z ]+$/.test(normalized)
            this.setHolderError(
                inputEl,
                ok ? '' : 'Nombre del titular de la tarjeta no válido'
            )
            return ok
        },

        setDataFastWidgetOptions({
            cardHolderName = '',
            submitLabel = 'Pagar',
            requireCvv = false,
            showPoweredBy = true,
        } = {}) {
            const callbackUrl = `${window.location.origin}/datafast-callback`
            const presetHolder = this.normalizeCardHolder(cardHolderName)

            window.wpwlOptions = {
                style: 'card',
                locale: 'es',
                brandDetection: true,
                shopperResultUrl: callbackUrl,
                labels: {
                    cvv: 'CVV',
                    cardHolder: 'Nombre(Igual que en la tarjeta)',
                    submit: submitLabel,
                },
                ...(requireCvv ? { registrations: { requireCvv: true } } : {}),
                onReady: () => {
                    if (showPoweredBy) this.insertDataFastPoweredByLogo()
                    this.removeDataFastInstallments()

                    const holder = this.getHolderInput()
                    if (holder) {
                        if (presetHolder) {
                            holder.value = presetHolder
                            holder.dispatchEvent(
                                new Event('input', { bubbles: true })
                            )
                        } else {
                            holder.value = ''
                        }

                        holder.addEventListener('input', () =>
                            this.clearHolderError(holder)
                        )
                        holder.addEventListener('blur', () =>
                            this.validateHolderInput(holder)
                        )
                    }
                },
                onBeforeSubmitCard: () => {
                    const holder = this.getHolderInput()
                    if (!holder) return true
                    return this.validateHolderInput(holder)
                },
            }
        },

        removeDataFastInstallments() {
            const form =
                document.querySelector('form.wpwl-form-card') ||
                document.querySelector('.wpwl-form-card') ||
                document.querySelector('form.paymentWidgets') ||
                document.querySelector('.paymentWidgets')

            if (!form) return

            const keywords = [
                'diferido',
                'diferidos',
                'cuota',
                'cuotas',
                'installment',
                'instalment',
            ]
            const shouldRemoveByText = (el) => {
                const text = (el?.textContent || '').toLowerCase()
                return keywords.some((k) => text.includes(k))
            }

            const removeGroup = (el) => {
                if (!el) return
                const group =
                    el.closest(
                        '.wpwl-group, .wpwl-wrapper, .wpwl-group-installments'
                    ) || el
                group.remove()
            }

            const selectorTargets = [
                '[name*="installment"]',
                '[name*="instalment"]',
                '[name*="cuota"]',
                '[name*="diferido"]',
                '[id*="installment"]',
                '[id*="instalment"]',
                '[id*="cuota"]',
                '[id*="diferido"]',
            ]

            selectorTargets.forEach((selector) => {
                form.querySelectorAll(selector).forEach((el) => removeGroup(el))
            })

            form.querySelectorAll(
                'label, .wpwl-label, .wpwl-title, .wpwl-group, .wpwl-wrapper'
            ).forEach((el) => {
                if (shouldRemoveByText(el)) removeGroup(el)
            })
        },

        removeDataFastScripts(preserveOptions = false) {
            const existingScript = document.querySelector(
                'script[src*="paymentWidgets.js"]'
            )
            if (existingScript) existingScript.remove()

            this.clearDataFastWidgetDom()

            if (!preserveOptions && window.wpwlOptions) {
                delete window.wpwlOptions
            }
        },

        clearDataFastWidgetDom() {
            document
                .querySelectorAll('.wpwl-container')
                .forEach((el) => el.remove())
            const container = document.getElementById('datafast-widget')
            if (container) container.innerHTML = ''
        },

        loadDataFastWidget(
            checkoutId,
            environment = 'TEST',
            checkoutUrl = null
        ) {
            return new Promise((resolve, reject) => {
                const scriptUrl =
                    checkoutUrl && typeof checkoutUrl === 'string'
                        ? checkoutUrl.trim()
                        : (() => {
                              const base =
                                  this.getDataFastWidgetBase(environment)
                              return `${base}/v1/paymentWidgets.js?checkoutId=${checkoutId}`
                          })()

                const script = document.createElement('script')
                script.src = scriptUrl
                script.async = true
                script.onload = () => resolve()
                script.onerror = () => {
                    const err = new Error('Widget no cargó')
                    err.scriptUrl = scriptUrl
                    reject(err)
                }

                document.head.appendChild(script)
            })
        },

        async initializeDataFastSDK(
            checkoutId,
            environment = 'TEST',
            checkoutUrl = null
        ) {
            if (!checkoutId && !checkoutUrl)
                throw new Error(
                    'checkoutId o checkoutUrl es requerido para inicializar DataFast'
                )

            try {
                this.removeDataFastScripts(true)
                await this.loadDataFastWidget(
                    checkoutId,
                    environment,
                    checkoutUrl
                )
                return true
            } catch (error) {
                const scriptUrl = error?.scriptUrl || ''
                const isProd =
                    environment === 'PROD' ||
                    environment === 'P' ||
                    environment === 'LIVE'
                let message =
                    'No se pudo cargar el sistema de pagos. Abra la pestaña Red (Network), busque "paymentWidgets.js" y revise el código de respuesta (403 = dominio no autorizado por DataFast).'
                if (isProd) {
                    message +=
                        ' Pida a DataFast que autorice su dominio de producción para cargar el widget.'
                }
                if (scriptUrl) {
                    // eslint-disable-next-line no-console
                    console.error(
                        '[DataFast] URL del widget que no cargó:',
                        scriptUrl
                    )
                }
                showDataFastError(this, message, 'Error')
                return false
            }
        },

        getDataFastWidgetBase(environment = 'TEST') {
            const env = String(environment || '').toUpperCase()
            if (env === 'PROD' || env === 'P' || env === 'LIVE') {
                const prodBase =
                    process.env.VUE_APP_DATAFAST_WP_URL_PROD ||
                    process.env.VUE_APP_DATAFAST_WP_URL
                if (!prodBase)
                    throw new Error(
                        'Falta VUE_APP_DATAFAST_WP_URL_PROD para ambiente PROD'
                    )
                return prodBase
            }

            return (
                process.env.VUE_APP_DATAFAST_WP_URL_TEST ||
                process.env.VUE_APP_DATAFAST_WP_URL ||
                'https://eu-test.oppwa.com'
            )
        },

        createDataFastWidget() {
            const container = document.getElementById('datafast-widget')
            if (!container)
                throw new Error('Contenedor #datafast-widget no encontrado')
            container.innerHTML = ''
        },

        formatDataFastAmount(amount) {
            const n = Number(amount)
            return Number.isFinite(n) ? n.toFixed(2) : '0.00'
        },

        validateDataFastData(paymentData) {
            const validation = validateRecurringPayment(paymentData)
            return validation.errors
        },

        roundNumber(value, precision) {
            if (Number.isInteger(precision)) {
                const shift = 10 ** precision
                return Math.round(value * shift + 1e-14) / shift
            }
            return Math.round(value)
        },
    },
}
